'use client';

import type { ReactNode } from 'react';
import { useRef } from 'react';

import { TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { useInView } from '@/app/hooks/useInView';
import type { NavItemType } from '@/app/types/top-navigation';
import type { VehicleType } from '@/app/types/vehicle-type';
import { TopNavigation } from '@/components/layouts/top-navigation';
import { TopNavigationStyled } from '@/components/layouts/top-navigation/styles';
import { Box } from '@/components/shared/layout/box';

interface TopNavigationTransparentProps {
  Logo: ReactNode;
  vehicleType: VehicleType;
  items: NavItemType[];
}

export const TopNavigationTransparent = ({
  Logo,
  vehicleType = 'lcv',
  items = [],
}: TopNavigationTransparentProps) => {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const isScrolledToTop = useInView(sentinelRef, {
    rootMargin: '0px 0px -1px 0px',
    initialState: true,
    threshold: 0.1,
    once: false,
  });

  return (
    <>
      <TopNavigationStyled
        variant="transparent"
        showBackground={!isScrolledToTop}
        data-test={TOP_NAV_DATA_TEST.header}
      >
        <TopNavigation
          Logo={Logo}
          items={items}
          vehicleType={vehicleType}
          variant={isScrolledToTop ? 'transparent' : 'filled'}
        />
      </TopNavigationStyled>
      <Box
        ref={sentinelRef}
        position="absolute"
        marginTop="px"
        width="full"
        height="px"
        aria-hidden="true"
      />
    </>
  );
};
